import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const paths = [
  { title: "Junior Development", desc: "Fundamentals to competition. Ages 6–18.", tag: "Junior" },
  { title: "High Performance", desc: "Tournament prep. College pathway.", tag: "Elite" },
  { title: "Adult Squash", desc: "Start, train, compete at every stage.", tag: "Adult" },
  { title: "Private Coaching", desc: "Contact our manager to arrange.", tag: "1-on-1" },
];

const FindYourPath = () => (
  <section className="section" style={{ background: "var(--lrg-bg)" }} data-testid="find-path-section">
    <div className="container-custom">
      <div className="max-w-md mb-20">
        <p className="overline mb-5">Programs</p>
        <h2 className="font-editorial text-4xl sm:text-5xl font-medium text-[#F2EDE4] leading-[1.1]">
          Find your path.
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#1D1F21]">
        {paths.map((p, i) => (
          <Link key={p.title} to="/programs" className="group block bg-[#090B0C] p-10 transition-all duration-600 hover:bg-[#0F1112]" data-testid={`path-${i}`}>
            <p className="text-[9px] font-medium text-[#0D6B56] tracking-[0.2em] uppercase mb-10">{p.tag}</p>
            <h3 className="font-editorial text-2xl font-medium text-[#F2EDE4] mb-3 group-hover:text-[#0D6B56] transition-colors duration-500">{p.title}</h3>
            <p className="text-[11px] text-[#3A3D40] leading-[1.8] mb-8">{p.desc}</p>
            <ArrowRight className="w-3.5 h-3.5 text-[#1D1F21] group-hover:text-[#0D6B56] transition-all duration-500 group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default FindYourPath;
